// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file login_inbox_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { VaultMessageType } from "./vault_message_type_pb";
import { file_vault_message_type } from "./vault_message_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file login_inbox_service.proto.
 */
export const file_login_inbox_service: GenFile = /*@__PURE__*/
  fileDesc("Chlsb2dpbl9pbmJveF9zZXJ2aWNlLnByb3RvEgZkb21haW4iMgoQU2hvd0luYm94UmVxdWVzdBIMCgRzbHVnGAEgASgJEhAKCGFzX293bmVyGAIgASgIIvgBChFTaG93SW5ib3hSZXNwb25zZRIQCgh2YXVsdF9pZBgBIAEoCRIVCg1nZW5lcmF0aW9uX2lkGAIgASgJEhIKCnB1YmxpY19rZXkYAyABKAwSEAoIbWV0YWRhdGEYBCABKAkSRQoRb3JnYW5pemF0aW9uX2RhdGEYBSABKAsyKi5kb21haW4uU2hvd0luYm94UmVzcG9uc2UuT3JnYW5pemF0aW9uRGF0YRILCgN1cmwYBiABKAkSEAoIYmFzZV91cmwYByABKAkaLgoQT3JnYW5pemF0aW9uRGF0YRIMCgRuYW1lGAEgASgJEgwKBGljb24YAiABKAkiiQEKHkNyZWF0ZUxvZ2luSW5ib3hNZXNzYWdlUmVxdWVzdBIQCgh2YXVsdF9pZBgBIAEoCRIVCg1nZW5lcmF0aW9uX2lkGAIgASgJEiYKBHR5cGUYAyABKA4yGC5kb21haW4uVmF1bHRNZXNzYWdlVHlwZRIWCg5lbmNyeXB0ZWRfZGF0YRgEIAEoDCI7Ch9DcmVhdGVMb2dpbkluYm94TWVzc2FnZVJlc3BvbnNlEhgKEGluYm94X21lc3NhZ2VfaWQYASABKAkytgEKEUxvZ2luSW5ib3hTZXJ2aWNlEj0KBFNob3cSGC5kb21haW4uU2hvd0luYm94UmVxdWVzdBoZLmRvbWFpbi5TaG93SW5ib3hSZXNwb25zZSIAEmIKDUNyZWF0ZU1lc3NhZ2USJi5kb21haW4uQ3JlYXRlTG9naW5JbmJveE1lc3NhZ2VSZXF1ZXN0GicuZG9tYWluLkNyZWF0ZUxvZ2luSW5ib3hNZXNzYWdlUmVzcG9uc2UiAEIwWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiYgZwcm90bzM", [file_vault_message_type]);

/**
 * @generated from message domain.ShowInboxRequest
 */
export type ShowInboxRequest = Message<"domain.ShowInboxRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: bool as_owner = 2;
   */
  asOwner: boolean;
};

/**
 * Describes the message domain.ShowInboxRequest.
 * Use `create(ShowInboxRequestSchema)` to create a new message.
 */
export const ShowInboxRequestSchema: GenMessage<ShowInboxRequest> = /*@__PURE__*/
  messageDesc(file_login_inbox_service, 0);

/**
 * @generated from message domain.ShowInboxResponse
 */
export type ShowInboxResponse = Message<"domain.ShowInboxResponse"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * @generated from field: bytes public_key = 3;
   */
  publicKey: Uint8Array;

  /**
   * @generated from field: string metadata = 4;
   */
  metadata: string;

  /**
   * @generated from field: domain.ShowInboxResponse.OrganizationData organization_data = 5;
   */
  organizationData?: ShowInboxResponse_OrganizationData | undefined;

  /**
   * @generated from field: string url = 6;
   */
  url: string;

  /**
   * the url prefix without trailing slash ("https://heylogin.me")
   *
   * @generated from field: string base_url = 7;
   */
  baseUrl: string;
};

/**
 * Describes the message domain.ShowInboxResponse.
 * Use `create(ShowInboxResponseSchema)` to create a new message.
 */
export const ShowInboxResponseSchema: GenMessage<ShowInboxResponse> = /*@__PURE__*/
  messageDesc(file_login_inbox_service, 1);

/**
 * @generated from message domain.ShowInboxResponse.OrganizationData
 */
export type ShowInboxResponse_OrganizationData = Message<"domain.ShowInboxResponse.OrganizationData"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string icon = 2;
   */
  icon: string;
};

/**
 * Describes the message domain.ShowInboxResponse.OrganizationData.
 * Use `create(ShowInboxResponse_OrganizationDataSchema)` to create a new message.
 */
export const ShowInboxResponse_OrganizationDataSchema: GenMessage<ShowInboxResponse_OrganizationData> = /*@__PURE__*/
  messageDesc(file_login_inbox_service, 1, 0);

/**
 * @generated from message domain.CreateLoginInboxMessageRequest
 */
export type CreateLoginInboxMessageRequest = Message<"domain.CreateLoginInboxMessageRequest"> & {
  /**
   * @generated from field: string vault_id = 1;
   */
  vaultId: string;

  /**
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * @generated from field: domain.VaultMessageType type = 3;
   */
  type: VaultMessageType;

  /**
   * @generated from field: bytes encrypted_data = 4;
   */
  encryptedData: Uint8Array;
};

/**
 * Describes the message domain.CreateLoginInboxMessageRequest.
 * Use `create(CreateLoginInboxMessageRequestSchema)` to create a new message.
 */
export const CreateLoginInboxMessageRequestSchema: GenMessage<CreateLoginInboxMessageRequest> = /*@__PURE__*/
  messageDesc(file_login_inbox_service, 2);

/**
 * @generated from message domain.CreateLoginInboxMessageResponse
 */
export type CreateLoginInboxMessageResponse = Message<"domain.CreateLoginInboxMessageResponse"> & {
  /**
   * @generated from field: string inbox_message_id = 1;
   */
  inboxMessageId: string;
};

/**
 * Describes the message domain.CreateLoginInboxMessageResponse.
 * Use `create(CreateLoginInboxMessageResponseSchema)` to create a new message.
 */
export const CreateLoginInboxMessageResponseSchema: GenMessage<CreateLoginInboxMessageResponse> = /*@__PURE__*/
  messageDesc(file_login_inbox_service, 3);

/**
 * @generated from service domain.LoginInboxService
 */
export const LoginInboxService: GenService<{
  /**
   * errors:
   * - VaultNotFound (50400): no vault for this slug
   * - VaultInboxSlugInvalid (50470)
   * - Internal (10500)
   *
   * @generated from rpc domain.LoginInboxService.Show
   */
  show: {
    methodKind: "unary";
    input: typeof ShowInboxRequestSchema;
    output: typeof ShowInboxResponseSchema;
  },
  /**
   * errors:
   * - VaultNotFound (50400)
   * - InvalidVaultMessageType (50463): vault message type not allowed for this endpoint
   * - VaultOutOfSync (50100)
   * - Internal (10500)
   *
   * @generated from rpc domain.LoginInboxService.CreateMessage
   */
  createMessage: {
    methodKind: "unary";
    input: typeof CreateLoginInboxMessageRequestSchema;
    output: typeof CreateLoginInboxMessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_login_inbox_service, 0);

